export default __webpack_public_path__ + "static/media/icon-contracts.7e81a0ff.svg";